import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
export const legalDocumentTypeSchema = z.enum(['privacy', 'terms', 'pics', 'subscription_terms']);
export const legalDocumentLocaleSchema = z.enum(['en', 'zh-Hant', 'zh-Hans']);
const legalTextSchema = z.string().trim().min(1).max(100000);
const legalVersionSchema = z.string().trim().min(1).max(50);
export const legalDocumentTypeParamSchema = z.object({
    type: legalDocumentTypeSchema,
});
export const legalDocumentIdParamSchema = z.object({
    id: uuidSchema,
});
export const publicLegalDocumentQuerySchema = z.object({
    locale: legalDocumentLocaleSchema.default('en'),
});
export const adminLegalDocumentListQuerySchema = z.object({
    type: legalDocumentTypeSchema.optional(),
    includeInactive: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .optional()
        .transform((value) => {
        if (typeof value === 'boolean') {
            return value;
        }
        if (value === 'true') {
            return true;
        }
        return false;
    }),
});
export const createLegalDocumentInputSchema = z.object({
    documentType: legalDocumentTypeSchema,
    locale: legalDocumentLocaleSchema.default('en'),
    version: legalVersionSchema,
    title: legalTextSchema.max(500),
    content: legalTextSchema,
    isActive: z.boolean().default(false),
    effectiveFrom: z.string().trim().max(30).optional(),
});
export const updateLegalDocumentInputSchema = z
    .object({
    documentType: legalDocumentTypeSchema.optional(),
    locale: legalDocumentLocaleSchema.optional(),
    version: legalVersionSchema.optional(),
    title: legalTextSchema.max(500).optional(),
    content: legalTextSchema.optional(),
    isActive: z.boolean().optional(),
    effectiveFrom: z.string().trim().max(30).optional(),
})
    .refine((value) => Object.keys(value).length > 0, {
    message: 'At least one field is required',
});
//# sourceMappingURL=legalDocument.schema.js.map